import { useNavigate } from 'react-router-dom';
import MobileFrame from '@/components/MobileFrame';
import { Icon } from '@/components/Icons';
import { useT } from '@/lib/i18n';
import { useOnboardingStore } from '@/lib/store';

export default function SuccessScreen() {
    const t = useT();
    const navigate = useNavigate();
    const registrationId = useOnboardingStore((s) => s.registrationId);

    const regCode = registrationId
        ? `PRN-${new Date().getFullYear()}-${String(registrationId).padStart(8, '0')}`
        : '—';

    return (
        <MobileFrame>
            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '40px 24px 32px',
                    textAlign: 'center',
                }}
                className="fade-in"
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 20,
                        marginBottom: 32,
                        position: 'relative',
                    }}
                >
                    <div style={{ position: 'relative', width: 140, height: 140 }}>
                        {[0, 1, 2].map((i) => (
                            <div
                                key={i}
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    borderRadius: '50%',
                                    background: 'var(--primary)',
                                    opacity: 0.08,
                                    animation: `ringPulse 2.4s var(--ease-out) ${i * 0.6}s infinite`,
                                }}
                            />
                        ))}
                        <div
                            style={{
                                position: 'absolute',
                                inset: 0,
                                borderRadius: '50%',
                                background:
                                    'linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 20px 40px rgba(11,61,145,0.3)',
                            }}
                        >
                            <Icon name="check" size={68} color="white" strokeWidth={2.5} />
                        </div>
                    </div>
                </div>

                <h1
                    style={{
                        fontSize: 26,
                        fontWeight: 700,
                        marginBottom: 10,
                        letterSpacing: '-0.02em',
                    }}
                >
                    {t.successTitle}
                </h1>
                <p
                    style={{
                        fontSize: 14,
                        lineHeight: 1.55,
                        color: 'var(--ink-500)',
                        marginBottom: 28,
                        padding: '0 8px',
                    }}
                >
                    {t.successSubtitle}
                </p>

                <div
                    style={{
                        padding: '14px 16px',
                        marginBottom: 16,
                        border: '1px dashed var(--ink-300)',
                        borderRadius: 12,
                        background: 'var(--ink-50)',
                    }}
                >
                    <div
                        style={{
                            fontSize: 11,
                            color: 'var(--ink-500)',
                            fontWeight: 600,
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            marginBottom: 4,
                        }}
                    >
                        {t.successId}
                    </div>
                    <div
                        style={{
                            fontSize: 16,
                            fontFamily: 'var(--font-mono)',
                            fontWeight: 600,
                            color: 'var(--ink-900)',
                            letterSpacing: '0.02em',
                        }}
                    >
                        {regCode}
                    </div>
                </div>

                <div
                    style={{
                        display: 'flex',
                        gap: 8,
                        padding: '10px 12px',
                        marginBottom: 20,
                        background: 'var(--success-soft)',
                        borderRadius: 10,
                        alignItems: 'center',
                        textAlign: 'left',
                    }}
                >
                    <Icon name="shieldCheck" size={18} color="var(--success)" />
                    <span
                        style={{
                            fontSize: 12,
                            lineHeight: 1.4,
                            color: 'var(--success)',
                            fontWeight: 500,
                        }}
                    >
                        {t.successAutoLoginNote}
                    </span>
                </div>

                <div style={{ flex: 1 }} />

                <button
                    type="button"
                    className="btn btn-secondary"
                    style={{ width: '100%', marginBottom: 10 }}
                    disabled
                >
                    <Icon name="download" size={16} color="var(--ink-700)" />
                    {t.successDownload}
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => navigate('/app/dashboard')}
                >
                    {t.successDashboard}
                </button>
            </div>
        </MobileFrame>
    );
}
